<template>
  <div class="ap-order-detail" v-show="!showLogistics">
    <div class="clearfix overflow-hidden">
      <div class="float-left">订单 {{record.number}} 详情</div>
      <div class="btn-wrap">
        <button
          v-if="status=='UNAUDITED'||status=='UNCONFIRM'"
          class="ap-btn-small ap-btn-bordered"
          @click="cancel"
        >取消订单</button>
        <button v-if="status=='DOING'||status=='FINISHED'" class="ap-btn-small ap-btn-bordered">申请售后</button>
        <button v-if="status=='DOING'||status=='FINISHED'" class="ap-btn-small ap-btn-bordered">评价</button>
        <button
          v-if="status=='DOING'||status=='FINISHED'"
          class="ap-btn-small ap-btn-bordered"
          @click="follow"
        >查看发货信息</button>
        <button
          v-if="status=='CANCEL'"
          @click="addToCart"
          class="ap-btn-small ap-btn-bordered"
        >加入采购车</button>
      </div>
    </div>
    <div class="order-header">
      <div class="wrap">
        <label>订单状态</label>
        <span v-if="status=='UNAUDITED'" class="badge badge-subtle badge-dark">审核中</span>
        <span v-if="status=='UNCONFIRM'" class="badge badge-orange">确认中</span>
        <span v-if="status=='DOING'" class="badge badge-subtle badge-success">执行中</span>
        <span v-if="status=='FINISHED'" class="badge badge-success">已完结</span>
        <span v-if="status=='CANCEL'" class="badge badge-subtle badge-secondary">已取消</span>
        <label>下单时间</label>
        <span>{{record.orderTime | toShortDateTime}}</span>
        <label>订单金额</label>
        <span style="color:#f03;">￥{{record.finalTotalAmount | toMoney}}</span>
        <label>制造商</label>
        <span>{{record.manufacturerName}}</span>
      </div>
    </div>
    <ul class="execute-steps row" v-if="status=='DOING'||status=='FINISHED'&&record.id">
      <li class="col-lg-2 active">
        <span class="align-items-center">
          <img src="@assets/icons/paper.png" alt />
        </span>
        <div>提交采购订单</div>
        <em>{{record.orderTime | toShortDateTime}}</em>
      </li>
      <li class="col-lg-2 active">
        <span>
          <img src="@/assets/icons/paperchecked.png" alt />
        </span>
        <div>确认采购订单</div>
        <em>{{record.confirmedTime | toShortDateTime}}</em>
      </li>
      <li class="col-lg-2" :class="{active:record.logistics.length}">
        <span>
          <img src="@assets/icons/truck1.png" alt />
        </span>
        <div>{{record.logistics.length?'物流配送中':'待发货'}}</div>
      </li>
      <li class="col-lg-2" :class="{active:logisticsStatus}">
        <span>
          <img src="@assets/icons/pallet.png" alt />
        </span>
        <div>确认收货</div>
        <!-- <em>{{ 1 | toShortDateTime }}</em> -->
      </li>
      <li class="col-lg-2" :class="{active:record.payStatus=='PAID'}">
        <span>
          <img src="@assets/icons/data.png" alt />
        </span>
        <div>货款结算</div>
        <!-- <em>{{ 1 | toShortDateTime }}</em> -->
      </li>
      <li class="col-lg-2" :class="{active:record.payStatus=='PAID'}">
        <span>
          <img src="@assets/icons/checked.png" alt />
        </span>
        <div>订单完成</div>
        <!-- <em>{{ 1 | toShortDateTime }}</em> -->
      </li>
    </ul>
    <div class="info gray-font-12">
      <div class="item">
        <div class="tit">收货人信息</div>
        <div>
          {{record.recLmName}} {{record.recLmTel}}
          <br />
          {{record.recProvince}} {{record.recCity}} {{record.recDistrict}} {{record.recDescription}}
          <br />
          {{record.buyerOrgName}}
          <br />配送方式：免费配送（公路物流）
        </div>
      </div>
      <div class="item">
        <div class="tit">支付方式</div>
        <div>
          支付方式：{{record.paymentMode}}
          <br />
          付款时间：{{record.paymentStatus}}
        </div>
      </div>
      <div class="item">
        <div class="tit">发票信息</div>
        <div>
          发票类型：增值税发票
          <br />
          开票抬头: {{record.invoiceName}}
        </div>
      </div>
    </div>
    <ul id="mylogistics" class="nav nav-tabs" style="margin-bottom:20px;">
      <li class="nav-item">
        <a
          class="nav-link show"
          :class="type=='detail'?'active':''"
          data-toggle="tab"
          @click="type='detail'"
        >商品明细</a>
      </li>
      <li v-show="status=='DOING'||status=='FINISHED'" class="nav-item">
        <a
          class="nav-link show"
          :class="type=='logistics'?'active':''"
          data-toggle="tab"
          @click="type='logistics'"
        >发货记录</a>
      </li>
    </ul>
    <div v-show="type=='detail'">
      <table class="table table-hover">
        <thead class="border-top">
          <tr>
            <th>商品名称</th>
            <th class="text-center" style="width:100px">商品编号</th>
            <th class="text-center" style="width:100px">商品货号</th>
            <th class="text-center" style="width:100px">交付包装类型</th>
            <th class="text-center" style="width:100px">包装数量</th>
            <th class="text-center" style="width:100px">采购件数</th>
            <th class="text-center" style="width:100px">单价(元)</th>
            <th class="text-center" style="width:100px">小计(元)</th>
          </tr>
        </thead>
        <tbody style="color:#666">
          <tr v-for="(item,idx) in record.pakiItems" :key="idx">
            <td class="clearfix">
              <router-link target="_blank" :to="'/sku/'+item.commodityId">
                <div class="float-left" style="width:60px;height:60px">
                  <img
                    v-if="item.pictureUri"
                    :src="getImgUrl(item.pictureUri)"
                    style="width:100%;max-height:100%;"
                  />
                  <img v-else src="@assets/images/no_image.png" style="width:100%;max-height:100%" />
                </div>
                <div style="margin-left:80px">
                  <div>{{item.commodityName}}</div>
                </div>
              </router-link>
            </td>
            <td class="text-center">{{item.commodityNumber}}</td>
            <td class="text-center">{{item.productNumber}}</td>
            <td class="text-left">
              {{item.pkgName}}
              <div>({{item.pkgLayLenQty}} x {{item.pkgLayWidQty}} x {{item.pkgLayHigQty}}{{item.pkgLayQtyUnit}})</div>
            </td>
            <td class="text-center border-right" style="width:20px;">{{item.packageQty}}</td>
            <td class="text-center">{{item.qty}}</td>
            <td class="text-center">{{item.unitPrice}}</td>
            <td
              class="text-right"
              style="color:#f03;"
            >{{multiply(item.unitPrice, item.qty) | toMoney}}</td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <td class="text-right">总计：</td>
            <td class="text-center">{{total.pkgs}}</td>
            <td class="text-center">{{total.qty}}</td>
            <td class="text-right" colspan="2">
              <strong style="color:#f03">￥{{total.price | toMoney}}</strong>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="money-wrap border-top border-bottom">
        <div class="item">
          <span class="amount">￥{{total.price | toMoney}}</span>
          <span class="tit">总商品金额：</span>
        </div>
        <div class="item">
          <span class="amount">-￥0.00</span>
          <span class="tit">折扣金额：</span>
        </div>
        <div class="item">
          <span class="amount">￥0.00</span>
          <span class="tit">配送费/运费：</span>
        </div>
        <div class="item">
          <strong class="amount" style="color:#f03">￥{{total.price | toMoney}}</strong>
          <strong class="tit" style="color:#f03">订单总金额：</strong>
        </div>
      </div>
    </div>
    <OrderLogistics v-show="type=='logistics'" @refresh="getData" :logistics="record.logistics"></OrderLogistics>
  </div>
</template>

<script>
import * as utils from "@common/utils";
import OrderLogistics from "./OrderLogistics.vue";

export default {
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  components: {
    OrderLogistics
  },
  data() {
    return {
      type: "detail",
      record: {
        confirmStatus: {},
        pakiItems: [],
        logistics: []
      }
    };
  },
  computed: {
    status() {
      let x = this.record;
      if (!x.id) return "";
      if (x.canceled === true) return "CANCEL";
      if (
        x.auditStatus === "UNAUDITED" ||
        x.auditStatus === "DISAPPROVED"
      )
        return "UNAUDITED";
      if (
        x.auditStatus == "APPROVED" &&
        x.confirmStatus == "UNCONFIRM"
      )
        return "UNCONFIRM";
      if (
        x.confirmStatus == "APPROVED" &&
        (x.payStatus == "UNPAID" || x.payStatus == "PAYING")
      )
        return "DOING";
      if (x.confirmStatus == "APPROVED" && x.payStatus == "PAID")
        return "FINISHED";
    },
    logisticsStatus() {
      if (!this.record.logistics.length) return;
      if (
        this.record.logistics.every(it => {
          return it.shippingStatus == "SHIPPED";
        })
      )
        return true;
    },
    showLogistics() {
      return this.$route.name == "logistics";
    },
    total() {
      let pkgs = 0;
      let qty = 0;
      let price = 0;
      this.record.pakiItems.forEach(x => {
        pkgs += x.packageQty;
        qty += x.pkgLayQty * x.packageQty;
        price += this.multiply(x.unitPrice, x.pkgLayQty * x.packageQty);
      });
      return { pkgs: pkgs, qty: qty, price: price };
    }
  },
  created() {
    this.getData();
  },
  methods: {
    addToCart() {
      let list = this.record.pakiItems;
      let items = [];
      let cart = [];
      list.forEach(x => {
        items.push({
          id: x.commodityId + "_" + x.commodityVn,
          pkgUuid: x.pkgId,
          qty: x.packageQty
        });
        cart.push({
          fileUri: this.getImgUrl(x.pictureUri) || "",
          name: x.commodityName,
          price: x.unitPrice,
          layQty: x.pkgLayQty,
          qty: x.packageQty
        });
      });
      this.$store.commit("changeCart", cart);
      this.$post("/bhome/carts/batchSave", { items })
        .then(() => {
          clearTimeout(window.cartTimeoutId);
          this.$store.commit("changeShowCart", true);
          window.cartTimeoutId = setTimeout(() => {
            this.$store.commit("changeShowCart", false);
          }, 3000);
        })
        .catch(err => {});
    },
    cancel() {
      if (!confirm("确认取消订单吗？")) return;
      this.$post("/opms/order/cancel/" + this.$route.params.id)
        .then(res => {
          this.getData();
        })
        .catch(err => {});
    },
    getData() {
      this.$get(
        "/opms/order/get/" + this.$route.params.id,
        {},
        {
          success(res) {
            res.logistics = res.logistics || [];
            res.logistics.forEach(item => {
              item.show = false;
            });
            this.record = res;
          }
        }
      );
    },
    multiply(arg1, arg2) {
      return utils.multiply(arg1, arg2);
    },
    follow() {
      this.type = "logistics";
      document.querySelector("#mylogistics").scrollIntoView(true);
    }
  }
};
</script>

<style lang="less">
.ap-order-detail {
  .btn-wrap {
    float: right;
    .ap-btn-small {
      margin-left: 10px;
    }
  }
  .order-header {
    margin-bottom: 30px;
    font-size: 12px;
    .wrap {
      margin: 10px 0;
      label {
        color: #aaa;
        margin-right: 20px;
      }
      span {
        margin-right: 60px;
      }
    }
  }
  .execute-steps {
    margin: -15px 0 0;
    padding: 30px 0;
    text-align: center;
    border-top: 1px solid #f2f2f2;
    li {
      color: #ccc;
      div {
        margin: 10px 0 5px;
      }
      em {
        display: block;
        width: 86px;
        margin: 0 auto;
        line-height: 1.2;
      }
    }
    em {
      font-size: 12px;
      font-style: normal;
    }
    span {
      display: flex;
      width: 67px;
      height: 67px;
      margin: 0 auto;
      border: 2px solid #ccc;
      border-radius: 50%;
      img {
        width: 32px;
        margin: 0 auto;
        align-self: center;
        opacity: 0.5;
      }
    }
    .active {
      span {
        border-color: #00cc65;
      }
      div {
        color: #000;
      }
      img {
        opacity: 1;
      }
    }
  }
  .info {
    display: flex;
    padding: 20px;
    color: #666;
    .item {
      flex: 1;
      .tit {
        margin-bottom: 10px;
      }
    }
  }
  .table {
    margin: 0;
    thead {
      background: #f6f7f9;
    }
    td {
      vertical-align: middle;
    }
  }
  .money-wrap {
    padding: 12px 0;
    .item {
      overflow: hidden;
      padding: 3px;
      .tit {
        float: right;
      }
      .amount {
        text-align: right;
        padding-right: 10px;
        float: right;
        width: 200px;
      }
    }
  }
}
</style>